// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonButton {
  background: rgb(255, 255, 255);
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.72) 0%, rgb(240, 89, 42) 50%, rgba(240, 89, 42, 0.59) 100%);
  border-radius: 12.9905277402vh !important;
  box-sizing: border-box;
  color: #fff !important;
  display: block;
  height: 8.6603518268vh;
  text-decoration: none;
  margin: 0 auto;
  padding: 2px !important;
  z-index: 2;
  margin-top: 3.247631935vh;
  box-shadow: none;
  border: 2px;
}
@media (max-width: 1200px) {
  .commonButton {
    height: 6.5vh;
    width: 21vh;
  }
}
@media (max-width: 768px) {
  .commonButton {
    height: 6.6603518268vh;
    width: 20vh;
  }
}

.commonButton:hover,
.commonButton:focus,
.commonButton:active {
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.72) 0%, rgb(240, 89, 42) 50%, rgba(240, 89, 42, 0.59) 100%) !important;
}

.commonButton span {
  color: white !important;
  align-items: center;
  background: #201b36 !important;
  border-radius: 5.4127198917vh !important;
  display: flex;
  justify-content: center;
  height: 100%;
  transition: background 0.5s ease;
  width: 100%;
  font-size: 2.4357239513vh !important;
  font-weight: 500 !important;
  padding: 1rem 1.5rem 1rem 1.5rem !important;
}
@media (max-width: 576px) {
  .commonButton span {
    font-size: 2.5vh !important;
  }
}

.linkTag {
  text-decoration: none;
}

.commonButton:hover span {
  background: #f0592a !important;
  color: white !important;
}

.Arrow {
  margin-left: 5%;
}`, "",{"version":3,"sources":["webpack://./src/Components/CommonButton/commonButton.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,qHAAA;EAMA,yCAAA;EACA,sBAAA;EACA,sBAAA;EACA,cAAA;EACA,sBAAA;EACA,qBAAA;EACA,cAAA;EACA,uBAAA;EAEA,UAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;AALF;AAME;EArBF;IAsBI,aAAA;IACA,WAAA;EAHF;AACF;AAIE;EAzBF;IA0BI,sBAAA;IACA,WAAA;EADF;AACF;;AAIA;;;EAGE,gIAAA;AADF;;AASA;EACE,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,wCAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,gCAAA;EACA,WAAA;EACA,oCAAA;EACA,2BAAA;EAEA,2CAAA;AAPF;AAQE;EAdF;IAeI,2BAAA;EALF;AACF;;AAOA;EACE,qBAAA;AAJF;;AAQA;EACE,8BAAA;EACA,uBAAA;AALF;;AAQA;EACE,eAAA;AALF","sourcesContent":[".commonButton {\n  background: rgb(255, 255, 255);\n  background: linear-gradient(\n    165deg,\n    rgba(255, 255, 255, 0.72) 0%,\n    rgba(240, 89, 42, 1) 50%,\n    rgba(240, 89, 42, 0.59) 100%\n  );\n  border-radius: 12.990527740189446vh !important;\n  box-sizing: border-box;\n  color: #fff !important;\n  display: block;\n  height: 8.660351826792963vh;\n  text-decoration: none;\n  margin: 0 auto;\n  padding: 2px !important;\n  // width: 21.650879566982407vh;\n  z-index: 2;\n  margin-top: 3.2476319350473615vh;\n  box-shadow: none;\n  border: 2px;\n  @media (max-width: 1200px) {\n    height: 6.5vh;\n    width: 21vh;\n  }\n  @media (max-width: 768px) {\n    height: 6.660351826792963vh;\n    width: 20vh;\n  }\n}\n\n.commonButton:hover,\n.commonButton:focus,\n.commonButton:active {\n  background: linear-gradient(\n    165deg,\n    rgba(255, 255, 255, 0.72) 0%,\n    rgba(240, 89, 42, 1) 50%,\n    rgba(240, 89, 42, 0.59) 100%\n  ) !important;\n}\n\n.commonButton span {\n  color: white !important;\n  align-items: center;\n  background: #201b36 !important;\n  border-radius: 5.412719891745602vh !important;\n  display: flex;\n  justify-content: center;\n  height: 100%;\n  transition: background 0.5s ease;\n  width: 100%;\n  font-size: 2.435723951285521vh !important;\n  font-weight: 500 !important;\n  // padding: auto !important;\n  padding: 1rem 1.5rem 1rem 1.5rem !important;\n  @media (max-width:576px) {\n    font-size: 2.5vh !important;\n  }\n}\n.linkTag {\n  text-decoration: none;\n  \n}\n\n.commonButton:hover span {\n  background: #f0592a !important;\n  color: white !important;\n}\n\n.Arrow {\n  margin-left: 5%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
